/**
 * @file m站 费用明细
 */

import React, {Component} from 'react';
import {NavBar, List, WingBlank, Icon} from 'antd-mobile';
import NavBarComponent from '../../component/common/NavBarComponent'
import Loading from '../../component/common/loading'
import {parseSearchToState} from '../../util/util.js';
import {Http, urls} from '../../api/index';
import './costDetail.scss';

const Item = List.Item;

class CostDetail extends Component {
    constructor() {
        super();
        this.state = {
            orderNo: '',
            orderInfo: {
                basicPriceDetails: [],
                optionalPriceDetails: [],
                couponDeductAmount: 0,
                reductionAmount: 0,
                shouldpayAmount: 0
            }
        };
    }

    componentDidMount() {
        const {history} = this.props;
        const search = history.location.search;
        let costDetailParams = parseSearchToState(search);
        setTimeout(() => {
            this.setState({
                orderNo: costDetailParams.orderNo
            });
            this.getDetail();
        }, 0);
    }

    getDetail() {
        let url = urls.OrderPrice;
        let data = {orderNo: this.state.orderNo};
        Http.post({url, data}).then(res => {
            this.setState({
                orderInfo: res.data
            })
        })
    }

    render() {
        return (
            <div id="costDetail" className="page">
                <NavBarComponent>
                    <NavBar 
                      icon={<Icon type="left" color='#333' />} 
                      onLeftClick={() => {this.props.history.goBack()}} 
                      mode='light'>费用明细</NavBar>
                </NavBarComponent>
                <WingBlank>
                    <div className="card h-shadow">
                        <div className="title">基本费用</div>
                        <List>
                            {this.state.orderInfo.basicPriceDetails.map((item, index) => {
                                return <Item className="item" key={index}>
                                            <span>{item.priceName}</span>
                                            <span>￥{item.totalPriceAmount.toFixed(2)}</span>
                                        </Item>
                            })}
                        </List>
                        {this.state.orderInfo.optionalPriceDetails.length!=0 ? 
                            <div>
                                <div className="mt10"></div><div className="title">可选服务</div>
                            </div> : 
                            <div style={{display: 'none'}}></div>
                        }
                        <List>
                            {this.state.orderInfo.optionalPriceDetails.map((item, index) => {
                                return <Item className="item" key={index}>
                                            <span>{item.priceName}</span>
                                            <span>￥{item.totalPriceAmount.toFixed(2)}</span>
                                        </Item>
                            })}
                        </List>
                        {this.state.orderInfo.couponDeductAmount>0 ? 
                            <div className="mt10">
                                <div className="item">
                                    <span>优惠金额</span>
                                    <span>-￥{this.state.orderInfo.couponDeductAmount.toFixed(2)}</span>
                                </div>
                            </div> : <div style={{display: 'none'}}></div>
                        }
                        {this.state.orderInfo.reductionAmount>0 ? 
                            <div className="mt10">
                                <div className="item">
                                    <span>已减免</span>
                                    <span>-￥{this.state.orderInfo.reductionAmount.toFixed(2)}</span>
                                </div>
                            </div> : <div style={{display: 'none'}}></div>
                        }
                        <div className="line mt10"></div>
                        <div className="sub">
                            <span>合计金额</span>
                            <span>￥{this.state.orderInfo.shouldpayAmount.toFixed(2)}</span>
                        </div>
                    </div>
                </WingBlank>
                <Loading/>
            </div>
        );
    }
}

export default CostDetail;
